"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NUTILITI_UTILITY_TYPES_MAP = exports.NUTILITI_BILL_CATEGORIES = exports.NUTILITI_BILL_CHARGE_TYPES_MAP = exports.UTILITY_BILL_EXTERNAL_SOURCES = exports.UTILITY_BILL_UPLOAD_TYPES = exports.UTILITY_BILL_UPLOAD_FORMATS = exports.UTILITY_BILL_STATUSES = exports.UTILITY_BILL_CHARGE_TYPES = exports.UTILITY_TYPES = exports.UTILITY_CHARGEBACK_STATUSES = exports.UTILITIES_RESPONSIBLE_PARTIES = void 0;
exports.UTILITIES_RESPONSIBLE_PARTIES = {
    UPANDUP: 'upandup',
    TENANT: 'tenant'
};
exports.UTILITY_CHARGEBACK_STATUSES = {
    PENDING: 'pending_triage',
    APPROVED: 'approved',
    REJECTED: 'rejected',
    DEFERRED: 'deferred'
};
exports.UTILITY_TYPES = {
    ELECTRIC: 'electric',
    GAS: 'gas',
    SEWER: 'sewer',
    STORMWATER: 'stormwater',
    TRASH: 'trash',
    WATER: 'water'
};
exports.UTILITY_BILL_CHARGE_TYPES = {
    SERVICE_CHARGE: 'service_charge',
    LATE_FEE: 'late_fee',
    DEPOSIT: 'deposit'
};
exports.UTILITY_BILL_STATUSES = {
    PENDING: 'pending',
    PAID: 'paid'
};
exports.UTILITY_BILL_UPLOAD_FORMATS = {
    CONSERVICE: 'conservice'
};
exports.UTILITY_BILL_UPLOAD_TYPES = {
    SCRUBBED: 'scrubbed'
};
exports.UTILITY_BILL_EXTERNAL_SOURCES = {
    CONSERVICE: 'conservice',
    NUTILITI: 'nutiliti'
};
exports.NUTILITI_BILL_CHARGE_TYPES_MAP = {
    MonthlyBill: 'SERVICE_CHARGE',
    FinalBill: 'SERVICE_CHARGE',
    Deposit: 'DEPOSIT',
    ServiceActivation: 'DEPOSIT'
};
exports.NUTILITI_BILL_CATEGORIES = {
    MONTHLY_BILL: 'MonthlyBill',
    FINAL_BILL: 'FinalBill',
    DEPOSIT: 'Deposit',
    SERVICE_ACTIVATION: 'ServiceActivation'
};
exports.NUTILITI_UTILITY_TYPES_MAP = {
    Electricity: 'ELECTRIC',
    Gas: 'GAS',
    Sewage: 'SEWER',
    StormWater: 'STORMWATER',
    Trash: 'TRASH',
    Water: 'WATER'
};
